
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class RegularContainer extends Vue {
    @Prop({ required: true, type: String })
    label!: string;

    @Prop({ default: '', type: String })
    description!: string;
}
